import React, { Suspense } from 'react'

const ReviewsPageBase = React.lazy(() => import('./Reviews'))

export const ReviewsPage = () => (
  <Suspense fallback={null}>
    <ReviewsPageBase />
  </Suspense>
)
